// extracted by mini-css-extract-plugin
export default {"remove":"BasketProductRemove-0knMF__remove","trash-icon":"BasketProductRemove-34qb9__trash-icon"};